import { TestModeEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';
import { Node } from 'slate';
import styled from 'styled-components';

import { useBlankEditorResult } from '../../BlogEditor/OnlineTestEditorPlugin.presets';
import { DolEditor } from '../../DolEditor/DolEditor';
import { BlankItemResult } from '../type';

export interface BlankEditorResultProps {
  value: Node[];
  blanks: BlankItemResult[];
  currentSelectedIndex?: number;
  showQuestionNo?: boolean;
  testMode: TestModeEnum;
}

const EditorContainer = styled.div``;

export const BlankEditorResult = (props: BlankEditorResultProps) => {
  const { value, blanks, currentSelectedIndex, showQuestionNo = true, testMode } = props;
  const { plugins, editorChains } = useBlankEditorResult({
    blanks,
    currentSelectedIndex,
    showQuestionNo,
    testMode,
  });

  return (
    <EditorContainer>
      <DolEditor
        forceValue
        renderElementDeps={[currentSelectedIndex, blanks]}
        placeholder="Start the sentence"
        plugins={plugins}
        editorChains={editorChains}
        initialValue={value}
        readOnly
        value={value}
      />
    </EditorContainer>
  );
};
